/**
 * Объяснение, с которым человека привели на главную после неудавшейся оплаты.
 *
 * Самым верхом экрана, над карточками платежей и заявок: это ответ на вопрос «почему я здесь»,
 * и он должен встретить человека раньше, чем он начнёт искать свой заказ.
 *
 * Баннер, а не тост: тост уходит сам через четыре секунды, а тут написано, что стало с деньгами.
 * Убирается только рукой — «Понятно» и есть подтверждение, что прочитали.
 */
import { useSyncExternalStore } from 'react';
import { Banner } from '@/shared/ui/Banner';
import { Button } from '@/shared/ui/Button';
import {
  dismissPaymentNotice,
  readPaymentNotice,
  subscribeToPaymentNotice,
} from './paymentNoticeStore';

export function PaymentNotice() {
  const text = useSyncExternalStore(subscribeToPaymentNotice, readPaymentNotice, readPaymentNotice);

  if (text === null) return null;

  return (
    <Banner
      tone="warning"
      title="Оплата"
      action={
        <Button variant="ghost" onClick={dismissPaymentNotice}>
          Понятно
        </Button>
      }
    >
      {text}
    </Banner>
  );
}
